import PageCEP from "./Views/PageCEP/PageCEP";

export default function App() {
  return <PageCEP />;
}
